import React, { useState,useEffect } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import Select from "react-select";
import SystemPipeLineListsScreenAPI from "../../services/systempipeline-lists-screen-service";

const AddSystemPipeLine = (props) => {
  const { isModalOpen, handleModalClose } = props;
  const { addSystemPipeLine } =
    props.SystemPipeLineListsScreenStore;
  const { CommonStore } = props;
  const [systemData,setSystemData] = useState({});
  const [spSystem, setSpSystem] = useState("");
  const [spSubSystem, setSpSubSystem] = useState("");
  const [spPipeLine, setSpPipeLine] = useState("");
  const [spActiveStatus, setSpActiveStatus] = useState({label: "Active",
  value: 1});
  const [spErrorMessage, setSpErrorMessage] = useState("");
    useEffect(() => {
    async function SystemData() {
      let systemdata =  await SystemPipeLineListsScreenAPI.getSystemData(CommonStore);
      let s = systemdata.data
      .filter(filter_data => filter_data.status === true)
      .map(({ systemName:label, id: id }) => ({ label, id }));
      setSystemData(s);
    }
    SystemData();
  }, []);

  const isDataValid = () => {
    console.log('spActiveStatus',spActiveStatus);
    console.log(Object.keys(spActiveStatus).length);
    if ((Object.keys(spActiveStatus).length>0) && spSystem && spPipeLine) {
      return true;
    }
    return false;
  };

  const handleAddSystemPipeLine = () => {
    if (!isDataValid()) {
      setSpErrorMessage("Kindly enter mandatory fields");
      return;
    }
    /* Data update 
      {"SystemName":"Jeeva system 1","SubSystemName":"Jeeva sub system 1","LineName":"Jeeva Line 1","Status":0,"CreatedBy":null,"CreatedDate":null,"UpdatedBy":null,"UpdatedDate":null}
    */

      console.log('active');
      console.log(spActiveStatus);

    addSystemPipeLine(
      {
        SystemName: spSystem?.id,
        SubSystemName:spSubSystem,
        LineName:spPipeLine,
        Status: spActiveStatus?.value,
      },
      CommonStore
    );
    handleClose();
  };

  const handleClose = () => {
    setSpSystem("");
    setSpSubSystem("");
    setSpPipeLine("");
    setSpActiveStatus({
      label: "Active",
      value: 1,
    });
    setSpErrorMessage("");
    handleModalClose();
  };

  return (
    <div className="add-entity-dialog">
      <Modal show={isModalOpen} onHide={handleClose}>
        <Modal.Header>
          <Modal.Title>Dig Master Tracker - Add Pipeline</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {spErrorMessage && <div className="error-message">{spErrorMessage}</div>}
          <Form>
            <Form.Group className="mb-3" controlId="spSystem">
              <Form.Label>System *</Form.Label>
              {/* <Form.Control
                type="input"
                value={spSystem}
                onChange={(event) => setSpSystem(event.target.value)}
                required
              /> */}
              {/* <Form.Select aria-label="spSystem">
                <option value="">Select System</option>
                {systemList}
              </Form.Select> */}
              <Select
                className=""
                options={systemData}
                value={spSystem}
                onChange={(value) => setSpSystem(value)}
              />
            </Form.Group>

            {/* <Form.Group controlId="spSubSystem">
              <Form.Label>Sub System *</Form.Label>
              <Form.Control
                type="input"
                value={//spSubSystem}
                onChange={//(event) => setSpSubSystem(event.target.value)}
                required
              />
            </Form.Group> */}

            <Form.Group controlId="spPipeLine">
              <Form.Label>Pipeline *</Form.Label>
              <Form.Control
                type="input"
                value={spPipeLine}
                onChange={(event) => setSpPipeLine(event.target.value)}
                required
              />
            </Form.Group>
            
            <Form.Group className="mb-3" controlId="spActiveStatus" style={{display:'none'}}> 
              <Form.Label>Active/Inactive *</Form.Label>
              <Select
                className="active-status-dropdown"
                options={[
                  { label: "Active", value: 1 },
                  { label: "Inactive", value: 0 },
                ]}
                value={spActiveStatus}
                onChange={(value) => setSpActiveStatus(value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddSystemPipeLine}>
            Add
          </Button>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default AddSystemPipeLine;
